import type { ReactNode } from 'react';
import { Label } from '@immo/ui-kit';

type FormFieldProps = {
  readonly id: string;
  readonly label: string;
  readonly required?: boolean;
  readonly helper?: string;
  readonly error: string | null;
  readonly children: (errorId: string | undefined) => ReactNode;
};

export function FormField({ id, label, required, helper, error, children }: FormFieldProps) {
  const errorId = `${id}-error`;
  const helperId = `${id}-helper`;

  return (
    <div className="space-y-1">
      <Label htmlFor={id}>
        {label}
        {required === true && <span className="ml-0.5 text-danger-600">*</span>}
      </Label>
      {children(error !== null ? errorId : undefined)}
      {error !== null ? (
        <p id={errorId} role="alert" className="text-sm text-danger-600">
          {error}
        </p>
      ) : helper !== undefined ? (
        <p id={helperId} className="text-sm text-text-tertiary">
          {helper}
        </p>
      ) : null}
    </div>
  );
}
